function klarnaPriceUpdate(PriceUpdate)
  {
     var KlarnaPrice = parseFloat(PriceUpdate)/4;
      console.log(KlarnaPrice.toFixed(2));
     $('span.Klarna-cart-price').text('$'+KlarnaPrice.toFixed(2));
  }

var items_collecion = [];
  function discount_calculated()
  {
        //var total_price = {{ cart.total_price | money_without_currency }};
        var cart_items = [];
        $.getJSON( "https://ansonbelt.com/cart.json", function(cart_data)
        {
          console.log(cart_data);
           var check_no_box = false;
              var qty = 0;
            $.each( cart_data.items, function( cart_key, cart_val ) {
                var check = items_collecion.includes(cart_val.handle);
                if(check)
                {
                  qty=parseInt(qty)+parseInt(cart_val.quantity); 
                }
                 check_no_box = cart_val.handle.includes("no-box");
            });
        
          if(qty==5)
          {
            var total_discount = (cart_data.total_discount);
                if(total_discount < 1)
                {
                  var total_price = ((cart_data.total_price)-2496);
                  total_price=parseFloat(total_price/100);
                  $('input[name="discount"]').val('Box Set Combination');
                  $('p.totals__subtotal-value').text("$"+total_price+" USD");
               // $('span.cart__subtotal').text();
                  $('del.h3.cart__subtotal.compare_price').text("$"+parseFloat((cart_data.original_total_price)/100));
                  $('del.h3.cart__subtotal.compare_price').show();
                  klarnaPriceUpdate(total_price);
                }
                else
                {
                   var total_price = (cart_data.total_price);
                   total_price=parseFloat(total_price/100);
                  $('input[name="discount"]').val('Box Set Combination');
                 $('p.totals__subtotal-value').text("$"+total_price+" USD");
               // $('span.cart__subtotal').text();
                 $('del.h3.cart__subtotal.compare_price').text("$"+parseFloat((cart_data.original_total_price)/100));
                 $('del.h3.cart__subtotal.compare_price').show();
                 klarnaPriceUpdate(total_price);
                }
          }
          else if(qty>5)
          {
               var total_discount = (cart_data.total_discount);
               if(total_discount < 1)
              {
               var total_price = ((cart_data.total_price)-3496);
               total_price=parseFloat(total_price/100);
               $('p.totals__subtotal-value').text("$"+total_price+" USD");
               $('del.h3.cart__subtotal.compare_price').text("$"+parseFloat((cart_data.original_total_price)/100));
               $('del.h3.cart__subtotal.compare_price').show();
               $('input[name="discount"]').val('Box Set Combination (6-piece)');
                 klarnaPriceUpdate(total_price);
              }
              else if(qty>5 && total_discount < 2497)
              {
                var total_price = ((cart_data.original_total_price)-3496);
                total_price=parseFloat(total_price/100);
                $('p.totals__subtotal-value').text("$"+total_price+" USD");
                $('del.h3.cart__subtotal.compare_price').text("$"+parseFloat((cart_data.original_total_price)/100));
                $('del.h3.cart__subtotal.compare_price').show();
                $('input[name="discount"]').val('Box Set Combination (6-piece)');
                 klarnaPriceUpdate(total_price);
              }
            else
               {
                  var total_price = (cart_data.total_price);
                 total_price=parseFloat(total_price/100);
                $('input[name="discount"]').val('Box Set Combination (6-piece)');
               $('p.totals__subtotal-value').text("$"+total_price+" USD");
             // $('span.cart__subtotal').text();
               $('del.h3.cart__subtotal.compare_price').text("$"+parseFloat((cart_data.original_total_price)/100));
               $('del.h3.cart__subtotal.compare_price').show();
               klarnaPriceUpdate(total_price);
               }
          }
          
       });
  }
function loaddiscount()
  {
        $.getJSON( "https://ansonbelt.com/collections/bucklesalls/products.json?limit=150", function( data)
        {
            $.each( data.products, function( key, val ) 
            {
              var primer = ["1-25-dark-brown-crocodile-strap","1-25-cognac-crocodile-strap","1-25-black-crocodile-strap","1-25-black-italian-calfskin-strap","1-25-cognac-italian-calfskin-strap","1-25-brown-italian-calfskin-strap","1-25-tan-italian-calfskin-strap","1-25-merlot-italian-calfskin-strap","1-25-dark-brown-calfskin-strap"];
              var n = primer.indexOf(val.handle);
              if(n<0)
              {
               items_collecion.push(val.handle);
              }
            });
        });
    $.getJSON( "https://ansonbelt.com/collections/strapsalls/products.json?limit=300", function( data)
     {
        $.each( data.products, function( key, val ) 
        {
          var primer = ["1-25-dark-brown-crocodile-strap","1-25-cognac-crocodile-strap","1-25-black-crocodile-strap","1-25-black-italian-calfskin-strap","1-25-cognac-italian-calfskin-strap","1-25-brown-italian-calfskin-strap","1-25-tan-italian-calfskin-strap","1-25-merlot-italian-calfskin-strap","1-25-dark-brown-calfskin-strap"];
          var n = primer.indexOf(val.handle);
          if(n<0)
          {
          items_collecion.push(val.handle);
          }
        });
         discount_calculated();
     });
  }


  
